import { VIP_LOGO } from '../../../../config/constants/images';

export const PROGRESS_MESSAGE_SUCCESS = 'Purchase Successful';
export const VIP_PAYWALL = {
  paywallDividerText:
    'Add more WOW to your savings and receive exclusive access to offers, codes and discounts',
  paywallHeader: `<p>Want more <span class="paywall-header-wow">WOW</span> from 5pm? </p>`,
  paywallHomeLink: `I don't want to save more right now`,
  paywallLoginTitle: 'You have to be logged in to access these savings!',
  paywallSavingsButton: 'START SAVING NOW',
  paywallSubtitle: `<p>Save up to an <span class="paywall-content-subtitle-higlighted">EXTRA 10%</span> with a year of <img
    alt="Logo"
    className="paywall-content-vip-image"
    src=${VIP_LOGO}
    style="margin-top: -10px; transform: rotate(-20deg); height: 70px; padding-left: 0px;"
    /><span class="paywall-content-subtitle-higlighted"> for £4.99</span></p>`,
  paywallSubtitleMobile: `<p>Save up to an <span class="paywall-content-subtitle-higlighted">EXTRA 10%</span> with a year of <img
    alt="Logo"
    height=50px;
    className="paywall-content-vip-image"
    src=${VIP_LOGO}
    style="margin-top: -10px; transform: rotate(-20deg); padding-left: 0px;"
    /><span class="paywall-content-subtitle-higlighted">for £4.99</span></p>`,
  paywallSuccessMessage: 'Congratulations, You’ve become a 5pm VIP!',
};
